import styled from 'styled-components';

export const Container = styled.div`
  .hero-section {
    .header-logo {
      height: 36px;
      width: auto;
    }

    .badge-light-custom {
      background: #ffffff;
      border: 1px solid #e2e5ea;
      color: #21354a;
      border-radius: 999px;
      font-size: 14px;
      font-weight: 500;
      white-space: nowrap;
    }

    .badge-brand {
      background: ${(props) => props.theme.$bg_green_register};
      color: #ffffff;
      border-radius: 999px;
      font-size: 14px;
      font-weight: 600;
      white-space: nowrap;

      .material-icons {
        font-size: 14px;
      }
    }

    .avatar-img {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      border: 2px solid #ffffff;
      object-fit: cover;
      background: #e2e5ea;
    }

    .avatar-img + .avatar-img {
      margin-left: -10px;
    }

    .hero-title {
      font-size: 56px;
      line-height: 1.1;
      font-weight: 800;
      color: #21354a;
      letter-spacing: -0.02em;
    }

    .hero-subtitle {
      font-size: 26px;
      line-height: 1.25;
      font-weight: 500;
      color: #21354a;
      letter-spacing: -0.01em;
    }

    .hero-lede {
      font-size: 17px;
      line-height: 1.55;
      color: #5f6b7a;
      max-width: 520px;
    }

    .benefit-check {
      width: 20px;
      height: 20px;
      min-width: 20px;
      border-radius: 50%;
      background: #e6f4ec;
      color: ${(props) => props.theme.$bg_green_register};

      .material-icons {
        font-size: 12px;
      }
    }

    .benefit-text {
      font-size: 15px;
      color: #5f6b7a;
      line-height: 1.5;
    }

    @media (max-width: 960px) {
      .hero-title {
        font-size: 44px;
      }
      .hero-subtitle {
        font-size: 22px;
      }
    }

    @media (max-width: 720px) {
      .hero-title {
        font-size: 36px;
      }
      .hero-subtitle {
        font-size: 20px;
      }
    }
  }

  .feature-section {
    .feature-grid {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 16px;
    }

    @media (max-width: 1280px) {
      .feature-grid {
        grid-template-columns: repeat(4, 1fr);
      }
    }

    @media (max-width: 960px) {
      .feature-grid {
        grid-template-columns: repeat(3, 1fr);
      }
    }

    @media (max-width: 720px) {
      .feature-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
      }
    }

    .feature-title {
      font-size: 44px;
      line-height: 1.2;
      font-weight: 800;
      color: #21354a;
      letter-spacing: -0.015em;
    }

    .feature-subtitle {
      font-size: 17px;
      line-height: 1.5;
      color: #5f6b7a;
    }

    .feature-card {
      background: #ffffff;
      border: 1px solid #e2e5ea;
      border-radius: 16px;
      min-height: 156px;
      transition: border-color 0.15s ease, box-shadow 0.15s ease;

      &:hover {
        border-color: #cbd1d9;
        box-shadow: 0 1px 2px rgba(33, 53, 74, 0.04), 0 8px 24px rgba(33, 53, 74, 0.06);
      }
    }

    .feature-icon {
      width: 32px;
      height: 32px;
    }

    .feature-label {
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      color: #21354a;
      line-height: 1.4;
    }

    @media (max-width: 960px) {
      .feature-title {
        font-size: 32px;
      }
    }

    @media (max-width: 720px) {
      .feature-title {
        font-size: 26px;
      }
      .feature-subtitle {
        font-size: 15px;
      }
    }
  }

  .ai-section {
    .ai-media-img {
      width: 100%;
      max-width: 400px;
      height: auto;
    }

    .ai-kicker {
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 0.1em;
      text-transform: uppercase;
      color: #5f6b7a;
    }

    .ai-title {
      font-size: 44px;
      line-height: 1.2;
      font-weight: 800;
      color: #21354a;
      letter-spacing: -0.015em;
    }

    .ai-brand {
      color: ${(props) => props.theme.$bg_green_register};
    }

    .ai-lede {
      font-size: 17px;
      line-height: 1.55;
      color: #5f6b7a;
    }

    .ai-subhead {
      font-size: 16px;
      font-weight: 700;
      color: #21354a;
    }

    .check-ring {
      width: 24px;
      height: 24px;
      min-width: 24px;
      border-radius: 50%;
      border: 2px solid ${(props) => props.theme.$bg_green_register};
      color: ${(props) => props.theme.$bg_green_register};
      background: transparent;

      .material-icons {
        font-size: 13px;
      }
    }

    .item-title {
      font-size: 16px;
      font-weight: 700;
      color: #21354a;
    }

    .item-body {
      font-size: 15px;
      line-height: 1.55;
      color: #5f6b7a;
    }

    @media (max-width: 1080px) {
      .ai-title {
        font-size: 38px;
      }
    }

    @media (max-width: 960px) {
      .ai-media-img {
        max-width: 280px;
      }
    }

    @media (max-width: 720px) {
      .ai-title {
        font-size: 28px;
      }
      .ai-lede {
        font-size: 16px;
      }
    }
  }

  .legal-section {
    .legal-title {
      font-size: 44px;
      line-height: 1.2;
      font-weight: 800;
      color: #21354a;
      letter-spacing: -0.015em;
    }

    .legal-lede {
      font-size: 17px;
      line-height: 1.55;
      color: #5f6b7a;
    }

    .check-ring {
      width: 24px;
      height: 24px;
      min-width: 24px;
      border-radius: 50%;
      border: 2px solid ${(props) => props.theme.$bg_green_register};
      color: ${(props) => props.theme.$bg_green_register};
      background: transparent;

      .material-icons {
        font-size: 13px;
      }
    }

    .item-title {
      font-size: 16px;
      font-weight: 700;
      color: #21354a;
    }

    .item-body {
      font-size: 15px;
      line-height: 1.55;
      color: #5f6b7a;
      max-width: 520px;
    }

    .legal-media-img {
      width: 100%;
      max-width: 400px;
      height: auto;
    }

    .cta-btn {
      background: ${(props) => props.theme.$bg_green_register};
      color: #ffffff;
      border-radius: 999px;
      font-size: 16px;
      font-weight: 700;
      border: 0;
      transition: background-color 0.15s ease, transform 0.05s ease;

      &:hover {
        background: ${(props) => props.theme.$dark_green};
        color: #ffffff;
      }

      &:active {
        transform: translateY(1px);
      }
    }

    @media (max-width: 1080px) {
      .legal-title {
        font-size: 38px;
      }
    }

    @media (max-width: 720px) {
      .legal-title {
        font-size: 28px;
      }
      .legal-lede {
        font-size: 16px;
      }
    }
  }

  .social-section {
    .social-card {
      background: ${(props) => props.theme.$bg_green_register};
      border-radius: 24px;
    }

    .social-title {
      color: #ffffff;
      font-size: 32px;
      line-height: 1.25;
      font-weight: 500;
      letter-spacing: -0.01em;

      strong {
        font-weight: 800;
      }
    }

    .video-wrapper {
      position: relative;
      width: 100%;
      aspect-ratio: 16 / 9;
      border-radius: 16px;
      overflow: hidden;
      background: rgba(0, 0, 0, 0.18);
    }

    .video-iframe {
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      border: 0;
    }

    @media (max-width: 1080px) {
      .social-title {
        font-size: 28px;
      }
    }

    @media (max-width: 720px) {
      .social-card {
        border-radius: 20px;
      }
      .social-title {
        font-size: 24px;
      }
    }
  }

  .bonus-section {
    .bonus-badge {
      background: ${(props) => props.theme.$yellow};
      color: #21354a;
      font-size: 12px;
      font-weight: 800;
      letter-spacing: 0.12em;
      text-transform: uppercase;
      border-radius: 12px;
    }

    .bonus-title {
      font-size: 34px;
      line-height: 1.2;
      font-weight: 800;
      color: #21354a;
      letter-spacing: -0.015em;
    }

    .bonus-body {
      font-size: 16px;
      line-height: 1.6;
      color: #5f6b7a;

      strong {
        color: #21354a;
        font-weight: 700;
      }
    }

    .bonus-img {
      width: 100%;
      max-width: 440px;
      height: auto;
      border-radius: 20px;
    }

    .cta-btn {
      background: ${(props) => props.theme.$bg_green_register};
      color: #ffffff;
      border-radius: 999px;
      font-size: 16px;
      font-weight: 700;
      border: 0;
      transition: background-color 0.15s ease, transform 0.05s ease;

      &:hover {
        background: ${(props) => props.theme.$dark_green};
        color: #ffffff;
      }

      &:active {
        transform: translateY(1px);
      }
    }

    @media (max-width: 1080px) {
      .bonus-title {
        font-size: 30px;
      }
    }

    @media (max-width: 720px) {
      .bonus-title {
        font-size: 24px;
      }
      .bonus-body {
        font-size: 15px;
      }
    }
  }

  .footer-section {
    border-top: 1px solid #e2e5ea;

    .footer-logo {
      height: 32px;
      width: auto;
    }

    .footer-link {
      font-size: 14px;
      font-weight: 500;
      color: #5f6b7a;
      text-decoration: underline;
      text-underline-offset: 4px;
      transition: color 0.15s ease;

      &:hover {
        color: #21354a;
      }
    }

    .footer-copy {
      font-size: 13px;
      color: #8a94a3;
    }
  }
`;
